import { Row } from 'react-bootstrap';
import Modal from '../../../../../../components/Modal';
import PropTypes from 'prop-types';

const OptionTileModal = ({ isOpen, onClose, title, options, handleOptionClick , saveLabel, handleSaveClick, additionalComponent  }) => {
  
  return (
    <>
      <Modal contentWidth="40%" isOpen={isOpen} titleName={title} onClose={onClose}>
        <div className='p-3'>
          <div className=" row gap-3 printing-options-wrapper mb-4">
            {options.map((item) => {
              return (
                <div
                  key={item.id}
                  className={`printing-options cursor-pointer col ${item.isActive ? 'active' : ''}`}
                  id={item.id}
                  onClick={handleOptionClick}>
                  {item.icon}
                  <h5>{item.label}</h5>
                </div>
              );
            })}
          </div>
          {additionalComponent && additionalComponent}
          { !(isOpen && additionalComponent) && <Row>
            <div className="d-flex justify-content-end gap-3 align-items-center">
              <button className="btn btn-castleGray option-btn" onClick={onClose}>
          Cancel
              </button>
              <button className="btn btn-castleRed option-btn" onClick={handleSaveClick}>
                {saveLabel}
              </button>        
            </div>  
          </Row>
          }   
        </div>
      </Modal>    
    </>
  );
};

OptionTileModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  additionalComponent: PropTypes.element,
  options:PropTypes.array,
  handleOptionClick:PropTypes.func,
  saveLabel:PropTypes.string,
  handleSaveClick:PropTypes.func
};

export default OptionTileModal;
